import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import EventsListPublicChild from "./EventsListPublicChild";

const EventsListPublic = () => {
  return (
    <MainTemplate>
      <EventsListPublicChild />
    </MainTemplate>
  );
};

export default EventsListPublic;
